export const meetingType = {
  lss: "lss",
  intake: "intake",
  cmn: "cmn",
} as const;

export const REQUIRED_VALIDATION_MESSAGE = "This is a required field";
